// This class is fallback storage when localStorage is blocked
var MemoryStorage = /** @class */ (function () {
    function MemoryStorage() {
        this.storage = new Map();
    }
    Object.defineProperty(MemoryStorage.prototype, "length", {
        get: function () {
            return this.storage.size;
        },
        enumerable: false,
        configurable: true
    });
    MemoryStorage.prototype.key = function (index) {
        return this.storage.keys()[index] || null;
    };
    MemoryStorage.prototype.getItem = function (key) {
        if (this.storage.has(key)) {
            return this.storage.get(key);
        }
        return null;
    };
    MemoryStorage.prototype.setItem = function (key, value) {
        this.storage.set(key, value);
    };
    MemoryStorage.prototype.removeItem = function (key) {
        this.storage.delete(key);
    };
    MemoryStorage.prototype.clear = function () {
        this.storage.clear();
    };
    return MemoryStorage;
}());var ffErrors = [
    'NS_ERROR_FAILURE',
    'NS_ERROR_FILE_CORRUPTED',
    'NS_ERROR_FILE_NO_DEVICE_SPACE',
];
var LocalStorage = /** @class */ (function () {
    function LocalStorage() {
        // to show error alert only once
        this.corruptedAlertWasShowed = false;
        if (!LocalStorage.isSupported(function () { return localStorage; })) {
            this.memoryLocalStorage = new MemoryStorage();
        }
        if (!LocalStorage.isSupported(function () { return sessionStorage; })) {
            this.memorySessionStorage = new MemoryStorage();
        }
    }
    // we should check it like this, to avoid "Operation Insecure" errors
    // add replace it with MemoryStorage
    LocalStorage.isSupported = function (getStorage) {
        try {
            var testKey = '__some_random_key_you_are_not_going_to_use__';
            getStorage().setItem(testKey, testKey);
            getStorage().removeItem(testKey);
            return true;
        }
        catch (error) {
            return false;
        }
    };
    LocalStorage.prototype.getLocalStorage = function () {
        return this.memoryLocalStorage || localStorage;
    };
    LocalStorage.prototype.getSessionStorage = function () {
        return this.memorySessionStorage || sessionStorage;
    };
    LocalStorage.prototype.get = function (name, storage) {
        try {
            return JSON.parse(storage.getItem(name));
        }
        catch (err) {
            if (ffErrors.includes(err.name)) {
                this.clear(storage);
                return null;
            }
            console.warn(err, {
                extra: {
                    name: name,
                },
            });
            this.remove(name, storage); // remove invalid data
            return null;
        }
    };
    LocalStorage.prototype.set = function (name, value, storage) {
        try {
            storage.setItem(name, JSON.stringify(value));
        }
        catch (err) {
            console.warn(err, {
                extra: {
                    name: name,
                    value: value,
                },
            });
            if (ffErrors.includes(err.name)) {
                this.clear(storage);
            }
        }
    };
    LocalStorage.prototype.remove = function (name, storage) {
        try {
            storage.removeItem(name);
        }
        catch (err) {
            console.warn(err, {
                extra: {
                    name: name,
                },
            });
        }
    };
    LocalStorage.prototype.clear = function (storage) {
        // Firefox corrupted file error, try to clean up the storage, and ignore error
        // https://stackoverflow.com/questions/18877643/error-in-local-storage-ns-error-file-corrupted-firefox
        try {
            console.info('clean up storage');
            storage.clear();
        }
        catch (error) {
            if (ffErrors.includes(error.name) && !this.corruptedAlertWasShowed) {
                alert('Sorry, it looks like your browser storage has been corrupted. '
                    + 'Please clear your storage by going to Tools -> Clear Recent History -> Cookies and set time range to \'Everything\'. '
                    + 'This will remove the corrupted browser storage across all sites.');
                this.corruptedAlertWasShowed = true;
            }
            console.info(error);
        }
    };
    LocalStorage.prototype.keys = function (storage) {
        var length = storage.length;
        var result = [];
        for (var i = 0; i < length; i++) {
            result.push(storage.key(i));
        }
        return result;
    };
    // localStorage
    LocalStorage.prototype.getItem = function (name) {
        return this.get(name, this.getLocalStorage());
    };
    LocalStorage.prototype.setItem = function (name, value) {
        this.set(name, value, this.getLocalStorage());
    };
    LocalStorage.prototype.updateItem = function (name, fn) {
        var item = this.getItem(name);
        this.set(name, fn(item), this.getLocalStorage());
    };
    LocalStorage.prototype.removeItem = function (name) {
        this.remove(name, this.getLocalStorage());
    };
    LocalStorage.prototype.getKeys = function () {
        return this.keys(this.getLocalStorage());
    };
    // session storage
    LocalStorage.prototype.getSessionItem = function (name) {
        return this.get(name, this.getSessionStorage());
    };
    LocalStorage.prototype.setSessionItem = function (name, value) {
        this.set(name, value, this.getSessionStorage());
    };
    LocalStorage.prototype.updateSessionItem = function (name, fn) {
        var item = this.getSessionItem(name);
        this.set(name, fn(item), this.getSessionStorage());
    };
    LocalStorage.prototype.removeSessionItem = function (name) {
        this.remove(name, this.getSessionStorage());
    };
    LocalStorage.prototype.getSessionKeys = function () {
        return this.keys(this.getSessionStorage());
    };
    return LocalStorage;
}());var index = new LocalStorage();export{index as default};